import { InfoTooltip } from "@/ui/index";

export function ResourceHoursHelpTooltip() {
  return (
    <InfoTooltip>
      <div className="text-base font-normal text-neutral-800">
        Custom hours allow admins to restrict reservations from being made for a
        period of time.{" "}
      </div>
    </InfoTooltip>
  );
}
